import Mooring from './Mooring';
export default class MooringArrivalLineHandling extends Mooring {
    type;
    line;
    lineArrangement;
    alongside;
    berth;
    constructor(port, type, line, lineArrangement, alongside, berth, freeText) {
        super(port, freeText);
        this.type = type;
        this.line = line;
        this.lineArrangement = lineArrangement;
        this.alongside = alongside;
        this.berth = berth;
    }
}
//# sourceMappingURL=MooringArrivalLineHandling.js.map